import { Injectable } from '@angular/core';
@Injectable()
export class OverrideReportingEffects {

  // @Effect()
  // loadOverrideReportingState$: Observable<Action> = this.actions$
  //   .ofType(OverrideReportingActionTypes.LoadOverrideReportingState)
  //   .startWith(new LoadOverrideReportingState())
  //   .switchMap(() =>
  //   // You can pull from offline state here or get data from a server via an api
  //   // An example of inserting data into offline state can be found in login.effects.ts
  //     this.db.query('override-reporting')
  //       .map((state: IOverrideReporting) => new LoadOverrideReportingStateSuccess(state))
  //       .catch(error => Observable.of(new LoadOverrideReportingStateFail(error)))
  //   );

}